import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsDetail from "../pages/news-detail/page";
import ApiNewsDetail from "../pages/api-news-detail/page";
import CreateBlog from "../pages/create-blog/page";
import BlogDetail from "../pages/blog-detail/page";
import Profile from "../pages/profile/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Admin from "../pages/admin/page";
import Privacy from "../pages/privacy/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/create-blog",
    element: <CreateBlog />,
  },
  {
    path: "/edit-blog/:id",
    element: <CreateBlog />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/api-news/:articleId",
    element: <ApiNewsDetail />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;